import type { FC } from "react";

import { BookmarkIconAsButton } from "components";
import { BlacklistIconAsButton } from "features/Blacklist/BlacklistToggleButton";
import { AssignmentHistoryButton } from "components/Buttons/AssignmentHistory";
import { SessionHistoryAssignmentsNavigation } from "features/AssignmentsNavigation/SessionHistoryAssignment";

interface Props {
  assignmentId: string;
  userAssignmentId: string;
  sessionId: string;
  onNavigate: (assignmentId: string) => void;
  title: string;
}

export const SessionHistoryAssignmentDetailHeader: FC<Props> = ({
  assignmentId,
  sessionId,
  title,
  userAssignmentId,
  onNavigate,
}) => (
  <div className="assignment-detail-header">
    <div className="assignment-detail-header__title">
      <h2 className="mb-0">{title}</h2>
    </div>
    <div className=" me-4px pe-2">
      <AssignmentHistoryButton userAssignmentId={userAssignmentId} assignmentId={assignmentId} />
    </div>
    <div className="border-start border-1 assignment-navigation px-2">
      <BlacklistIconAsButton className="ms-4px" userAssignmentId={userAssignmentId} />
      <BookmarkIconAsButton className="ms-4px" userAssignmentId={userAssignmentId} />
    </div>
    <div className="border-start border-1 ps-2">
      <SessionHistoryAssignmentsNavigation
        userAssignmentId={userAssignmentId}
        sessionId={sessionId}
        onNavigate={onNavigate}
      />
    </div>
  </div>
);
